import api from './api';

const FOOD_COUNTER_TRANSACTION_URL = '/api/food_counter/transaction/';

const sendTransaction = async (warehouseId, clientId, productIds) => {
  const response = await api({
    url: FOOD_COUNTER_TRANSACTION_URL,
    method: 'post',
    data: {
      warehouse: warehouseId,
      client: clientId,
      products: productIds,
    },
  });
  return response.data;
};

export default sendTransaction;
